import { LowerCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  inject,
} from '@angular/core';
import { AssetDto, GalleryDto } from '@nusign/picflow-backend-types';
import { downloadSizes } from '../../../consts';
import { GalleryAccessLevel } from '../../../lib/access-level';
import { getAllowedDownloadSizes } from '../../../lib/convert-gallery-download-size';
import { ButtonMenuItemComponent } from '../../../shared/components/button-menu-item/button-menu-item.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-download-size-selection',
  templateUrl: './download-size-selection.component.html',
  styleUrls: ['./download-size-selection.component.scss'],
  standalone: true,
  imports: [ButtonMenuItemComponent, SvgComponent, LowerCasePipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadSizeSelectionComponent implements OnChanges {
  private check = inject(ChangeDetectorRef);
  @Input() accessLevel: GalleryAccessLevel;
  @Input() asset: AssetDto;
  @Input() gallery: GalleryDto;
  @Input() previewWidth?: number;
  @Input() activeWidth?: number;
  @Output() onSelect = new EventEmitter();
  sizes = downloadSizes;
  allowOriginalDownload: boolean;

  ngOnChanges() {
    const resp = getAllowedDownloadSizes(this.gallery.download_media_size, this.accessLevel, this.asset);
    this.allowOriginalDownload = resp.allowOriginalDownload;
    this.sizes = resp.sizes;
    this.check.detectChanges();
  }

  getWidth(size: number) {
    if (!this.asset.version_data.data?.width) return;
    const aspect = this.asset.version_data.data.height / this.asset.version_data.data.width;
    if (aspect > 1) return size;
    return Math.round(size / aspect);
  }

  getHeight(size: number) {
    if (!this.asset.version_data.data?.width) return;
    const aspect = this.asset.version_data.data.height / this.asset.version_data.data.width;
    if (aspect < 1) return size;
    return Math.round(size * aspect);
  }
}
